export default "__VITE_ASSET__a9fATRz$rB7_JkAe8twOGA__"